import { useQuery } from '@apollo/client';
import get from 'lodash.get';
import { HiringStatus, ResourceRequestAccessLevel } from '~/types';
import { RESOURCE_ALLOCATION_CHART_SUB_TAB_ENUM } from '~/modules/resourcing/hooks/useResourceAllocationChartTabStateContext';
import { getResourcingPlansQuery as GET_RESOURCING_PLANS_QUERY } from '~/modules/resourcing/graphql';
import useLoadMoreResourcingPlans from './useLoadMoreResourcingPlans';

const useResourcingPlans = ({
  resourcePlanGroup,
  planFilter,
  requestAccessLevel = ResourceRequestAccessLevel.All,
  resourcePlanSubstatusFilter,
  isHiringStatusSubFilterEnabled
}) => {
  const { data, loading, fetchMore, networkStatus } = useQuery(
    GET_RESOURCING_PLANS_QUERY,
    {
      variables: {
        paginationToken: null,
        requestAccessLevel,
        filter: {
          ...planFilter,
          ...(isHiringStatusSubFilterEnabled && {
            hiringStatuses:
              resourcePlanSubstatusFilter ===
              RESOURCE_ALLOCATION_CHART_SUB_TAB_ENUM.HIRINGREQUESTED
                ? [HiringStatus.HiringRequested]
                : [],
            excludedHiringStatuses:
              resourcePlanSubstatusFilter ===
              RESOURCE_ALLOCATION_CHART_SUB_TAB_ENUM.TOBEHIRED
                ? [HiringStatus.HiringRequested, HiringStatus.HiringWithdrawn]
                : []
          })
        },
        groupBy: resourcePlanGroup
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first'
    }
  );

  const getResourcePlansForCurrentTenant =
    get(data, 'getResourcePlansForCurrentTenant') || {};

  const { plans = [], paginationToken } = getResourcePlansForCurrentTenant;

  const { loadMore } = useLoadMoreResourcingPlans({
    fetchMore,
    hasMore: Boolean(paginationToken),
    paginationToken,
    planFilter,
    networkStatus,
    requestAccessLevel
  });

  return {
    plans,
    paginationToken,
    loading,
    loadMorePlans: loadMore,
    hasMorePlans: Boolean(paginationToken)
  };
};

export default useResourcingPlans;
